import { axios } from 'common/axios';

import { SupportedApplications } from 'common/types/supported-applications.type';

export const fetchSupportedApplications =
  async (): Promise<SupportedApplications> => {
    const { data } = await axios.get('/api/supported-applications');

    return data;
  };
